export const Check = () => {
	return (
		<svg width={19} viewBox="0 0 19 19" fill="none">
			<path
				d="M15.818 4.74253C15.6123 4.74865 15.4171 4.83461 15.2737 4.98219L7.1251 13.1308L4.51817 10.5239C4.3196 10.317 4.02475 10.2337 3.74731 10.3061C3.46988 10.3784 3.25323 10.595 3.1809 10.8725C3.10857 11.1499 3.19189 11.4448 3.3987 11.6433L6.56536 14.81C6.87453 15.119 7.37566 15.119 7.68483 14.81L16.3932 6.10166C16.6273 5.87406 16.6977 5.52606 16.5704 5.22536C16.4432 4.92464 16.1444 4.73291 15.818 4.74253L15.818 4.74253Z"
				fill="#03DB80"
			/>
		</svg>
	);
};
export const Ellipsis = () => {
	return (
		<svg width={14} viewBox="0 0 14 5" fill="none">
			<path
				d="M5.94531 1.44531C6.25 1.14062 6.60156 0.988281 7 0.988281C7.39844 0.988281 7.75 1.14062 8.05469 1.44531C8.35938 1.75 8.51172 2.10156 8.51172 2.5C8.51172 2.89844 8.35938 3.25 8.05469 3.55469C7.75 3.85938 7.39844 4.01172 7 4.01172C6.60156 4.01172 6.25 3.85938 5.94531 3.55469C5.64062 3.25 5.48828 2.89844 5.48828 2.5C5.48828 2.10156 5.64062 1.75 5.94531 1.44531ZM10.4453 1.44531C10.75 1.14062 11.1016 0.988281 11.5 0.988281C11.8984 0.988281 12.25 1.14062 12.5547 1.44531C12.8594 1.75 13.0117 2.10156 13.0117 2.5C13.0117 2.89844 12.8594 3.25 12.5547 3.55469C12.25 3.85938 11.8984 4.01172 11.5 4.01172C11.1016 4.01172 10.75 3.85938 10.4453 3.55469C10.1406 3.25 9.98828 2.89844 9.98828 2.5C9.98828 2.10156 10.1406 1.75 10.4453 1.44531ZM1.44531 1.44531C1.75 1.14062 2.10156 0.988281 2.5 0.988281C2.89844 0.988281 3.25 1.14062 3.55469 1.44531C3.85938 1.75 4.01172 2.10156 4.01172 2.5C4.01172 2.89844 3.85938 3.25 3.55469 3.55469C3.25 3.85938 2.89844 4.01172 2.5 4.01172C2.10156 4.01172 1.75 3.85938 1.44531 3.55469C1.14062 3.25 0.988281 2.89844 0.988281 2.5C0.988281 2.10156 1.14062 1.75 1.44531 1.44531Z"
				fill="white"
			/>
		</svg>
	);
};
export const AngleLeft = () => {
	return (
		<svg width={48} viewBox="0 0 48 48" fill="none">
			<rect
				x={1}
				y={1}
				width={46}
				height={46}
				rx={23}
				stroke="#CFDBD5"
				strokeOpacity="0.15"
				strokeLinecap="square"
			/>
			<path
				d="M26.5664 27.4453L25.5117 28.5L21.0117 24L25.5117 19.5L26.5664 20.5547L23.1211 24L26.5664 27.4453Z"
				fill="white"
			/>
		</svg>
	);
};
export const AngleRight = () => {
	return (
		<svg width={48} height={48} viewBox="0 0 48 48" fill="none">
			<rect
				x={1}
				y={1}
				width={46}
				height={46}
				rx={23}
				stroke="#CFDBD5"
				strokeOpacity="0.15"
				strokeLinecap="square"
			/>
			<path
				d="M21.4336 27.4453L24.8789 24L21.4336 20.5547L22.4883 19.5L26.9883 24L22.4883 28.5L21.4336 27.4453Z"
				fill="white"
			/>
		</svg>
	);
};
export const Clock = () => {
	return (
		<svg width={16} viewBox="0 0 16 15" fill="none">
			<path
				d="M8.38672 3.73828V7.67578L11.7617 9.67969L11.1992 10.6289L7.26172 8.23828V3.73828H8.38672ZM3.74609 11.7539C4.94141 12.9258 6.35938 13.5117 8 13.5117C9.64062 13.5117 11.0469 12.9258 12.2188 11.7539C13.4141 10.5586 14.0117 9.14062 14.0117 7.5C14.0117 5.85937 13.4141 4.45312 12.2188 3.28125C11.0469 2.08594 9.64062 1.48828 8 1.48828C6.35938 1.48828 4.94141 2.08594 3.74609 3.28125C2.57422 4.45312 1.98828 5.85937 1.98828 7.5C1.98828 9.14062 2.57422 10.5586 3.74609 11.7539ZM2.69141 2.22656C4.16797 0.75 5.9375 0.0117188 8 0.0117188C10.0625 0.0117188 11.8203 0.75 13.2734 2.22656C14.75 3.67969 15.4883 5.4375 15.4883 7.5C15.4883 9.5625 14.75 11.332 13.2734 12.8086C11.8203 14.2617 10.0625 14.9883 8 14.9883C5.9375 14.9883 4.16797 14.2617 2.69141 12.8086C1.23828 11.332 0.511719 9.5625 0.511719 7.5C0.511719 5.4375 1.23828 3.67969 2.69141 2.22656Z"
				fill="white"
			/>
		</svg>
	);
};
export const Heart = () => {
	return (
		<svg width={16} viewBox="0 0 16 15" fill="none">
			<path
				d="M8.07031 12.4219C9.19531 11.4141 10.0273 10.6523 10.5664 10.1367C11.1055 9.62109 11.6914 9.01172 12.3242 8.30859C12.957 7.60547 13.3906 6.98438 13.625 6.44531C13.8828 5.90625 14.0117 5.37891 14.0117 4.86328C14.0117 4.11328 13.7539 3.49219 13.2383 3C12.7461 2.50781 12.125 2.26172 11.375 2.26172C10.7891 2.26172 10.2383 2.42578 9.72266 2.75391C9.23047 3.08203 8.89062 3.50391 8.70312 4.01953H7.29688C7.10938 3.50391 6.75781 3.08203 6.24219 2.75391C5.75 2.42578 5.21094 2.26172 4.625 2.26172C3.875 2.26172 3.24219 2.50781 2.72656 3C2.23438 3.49219 1.98828 4.11328 1.98828 4.86328C1.98828 5.37891 2.10547 5.90625 2.33984 6.44531C2.59766 6.98438 3.04297 7.60547 3.67578 8.30859C4.30859 9.01172 4.89453 9.62109 5.43359 10.1367C5.97266 10.6523 6.80469 11.4141 7.92969 12.4219L8 12.4922L8.07031 12.4219ZM11.375 0.75C12.5469 0.75 13.5195 1.14844 14.293 1.94531C15.0898 2.74219 15.4883 3.71484 15.4883 4.86328C15.4883 5.54297 15.3594 6.21094 15.1016 6.86719C14.8438 7.5 14.3633 8.21484 13.6602 9.01172C12.9805 9.80859 12.3594 10.4766 11.7969 11.0156C11.2344 11.5547 10.332 12.3867 9.08984 13.5117L8 14.4961L6.91016 13.5469C5.29297 12.0938 4.12109 11.0039 3.39453 10.2773C2.69141 9.55078 2.03516 8.69531 1.42578 7.71094C0.816406 6.72656 0.511719 5.77734 0.511719 4.86328C0.511719 3.71484 0.898438 2.74219 1.67188 1.94531C2.46875 1.14844 3.45312 0.75 4.625 0.75C5.98438 0.75 7.10938 1.27734 8 2.33203C8.89062 1.27734 10.0156 0.75 11.375 0.75Z"
				fill="white"
			/>
		</svg>
	);
};
export const ETHIcon = () => {
	return (
		<>
			<svg width={10} viewBox="0 0 10 16" fill="none">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.00066 0V5.9146L0.625613 7.87027L5.00066 5.91577V11.0508L0.00350887 8.14835L0.00334889 8.14841L0.00340222 8.1483L0.00334889 8.14824L0.00345554 8.14819L5.00066 0ZM5.00199 0L9.99984 8.14819L10 8.14824L9.99995 8.1483L10 8.14841L9.99984 8.14835L5.00199 11.0508V5.91577L9.37763 7.87027L5.00199 5.9146V0ZM5.00066 11.9812V16L0 9.07922L5.00066 11.9812ZM5.00199 16V11.9805L10 9.07922L5.00199 16Z"
					fill="#6B8CEF"
				/>
			</svg>
		</>
	);
};
export const VideoIcon = () => {
	return (
		<svg width={122} viewBox="0 0 122 122" fill="none">
			<g filter="url(#filter0_d_741_4275)">
				<rect x={22} y={14} width={78} height={78} rx={39} fill="#03DB80" />
				<rect
					x={17}
					y={9}
					width={88}
					height={88}
					rx={44}
					stroke="#CFDBD5"
					strokeOpacity="0.15"
					strokeWidth={10}
				/>
			</g>
			<path
				d="M72 49.5359C74.6667 51.0755 74.6667 54.9245 72 56.4641L58.5 64.2583C55.8333 65.7979 52.5 63.8734 52.5 60.7942L52.5 45.2058C52.5 42.1266 55.8333 40.2021 58.5 41.7417L72 49.5359Z"
				fill="white"
			/>
			<defs>
				<filter
					id="filter0_d_741_4275"
					x={0}
					y={0}
					width={122}
					height={122}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={8} />
					<feGaussianBlur stdDeviation={6} />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0313726 0 0 0 0 0.12549 0 0 0 0 0.196078 0 0 0 0.22 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_741_4275"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_741_4275"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
export const GlobeIcon = () => {
	return (
		<svg width={15} viewBox="0 0 15 15" fill="none">
			<path
				d="M11.9297 11.543C12.9844 10.418 13.5117 9.07031 13.5117 7.5C13.5117 6.25781 13.1602 5.13281 12.457 4.125C11.7773 3.11719 10.875 2.39063 9.75 1.94531V2.26172C9.75 2.66016 9.59766 3.01172 9.29297 3.31641C8.98828 3.59766 8.63672 3.73828 8.23828 3.73828H6.76172V5.25C6.76172 5.46094 6.67969 5.63672 6.51562 5.77734C6.375 5.91797 6.19922 5.98828 5.98828 5.98828H4.51172V7.5H9.01172C9.22266 7.5 9.39844 7.57031 9.53906 7.71094C9.67969 7.85156 9.75 8.02734 9.75 8.23828V10.4883H10.4883C11.1914 10.4883 11.6719 10.8398 11.9297 11.543ZM6.76172 13.4414V12C6.36328 12 6.01172 11.8477 5.70703 11.543C5.40234 11.2383 5.25 10.8867 5.25 10.4883V9.75L1.66406 6.16406C1.54688 6.63281 1.48828 7.07812 1.48828 7.5C1.48828 9.02344 1.99219 10.3477 3 11.4727C4.03125 12.5977 5.28516 13.2539 6.76172 13.4414ZM2.19141 2.22656C3.66797 0.75 5.4375 0.0117188 7.5 0.0117188C9.5625 0.0117188 11.3203 0.75 12.7734 2.22656C14.25 3.67969 14.9883 5.4375 14.9883 7.5C14.9883 9.5625 14.25 11.332 12.7734 12.8086C11.3203 14.2617 9.5625 14.9883 7.5 14.9883C5.4375 14.9883 3.66797 14.2617 2.19141 12.8086C0.738281 11.332 0.0117188 9.5625 0.0117188 7.5C0.0117188 5.4375 0.738281 3.67969 2.19141 2.22656Z"
				fill="white"
			/>
		</svg>
	);
};
export const BrightnessIcon = () => {
	return (
		<svg width={18} viewBox="0 0 18 18" fill="none">
			<path
				d="M5.80078 12.1992C6.69141 13.0664 7.75781 13.5 9 13.5C10.2422 13.5 11.2969 13.0664 12.1641 12.1992C13.0547 11.3086 13.5 10.2422 13.5 9C13.5 7.75781 13.0547 6.70313 12.1641 5.83594C11.2969 4.94531 10.2422 4.5 9 4.5C7.75781 4.5 6.69141 4.94531 5.80078 5.83594C4.93359 6.70313 4.5 7.75781 4.5 9C4.5 10.2422 4.93359 11.3086 5.80078 12.1992ZM15.0117 11.4961V15.0117H11.4961L9 17.4727L6.50391 15.0117H2.98828V11.4961L0.527344 9L2.98828 6.50391V2.98828H6.50391L9 0.527344L11.4961 2.98828H15.0117V6.50391L17.4727 9L15.0117 11.4961Z"
				fill="white"
			/>
		</svg>
	);
};
export const Envelop = () => {
	return (
		<svg width={16} viewBox="0 0 16 14" fill="none">
			<path
				d="M14.0117 4.01172V2.5L8 6.26172L1.98828 2.5V4.01172L8 7.73828L14.0117 4.01172ZM14.0117 0.988281C14.4102 0.988281 14.75 1.14062 15.0312 1.44531C15.3359 1.75 15.4883 2.10156 15.4883 2.5V11.5C15.4883 11.8984 15.3359 12.25 15.0312 12.5547C14.75 12.8594 14.4102 13.0117 14.0117 13.0117H1.98828C1.58984 13.0117 1.23828 12.8594 0.933594 12.5547C0.652344 12.25 0.511719 11.8984 0.511719 11.5V2.5C0.511719 2.10156 0.652344 1.75 0.933594 1.44531C1.23828 1.14062 1.58984 0.988281 1.98828 0.988281H14.0117Z"
				fill="white"
				fillOpacity="0.5"
			/>
		</svg>
	);
};
export const Facebook = () => {
	return (
		<>
			<svg width={9} viewBox="0 0 9 16" fill="none">
				<path
					d="M2.90624 16V8.84373H0.5V5.99999H2.90624V3.74999C2.90624 2.56249 3.23958 1.64062 3.90624 0.984373C4.57291 0.328124 5.45832 0 6.56249 0C7.45832 0 8.18748 0.0416664 8.74998 0.125V2.65624H7.24998C6.68749 2.65624 6.30207 2.78124 6.09374 3.03124C5.92707 3.23958 5.84374 3.57291 5.84374 4.03124V5.99999H8.49998L8.12498 8.84373H5.84374V16H2.90624Z"
					fill="white"
				/>
			</svg>
		</>
	);
};
export const Slack = () => {
	return (
		<>
			<svg width={17} viewBox="0 0 17 16" fill="none">
				<path
					d="M6.59057 1C5.88714 1.00052 5.31784 1.57044 5.31836 2.27273C5.31784 2.97501 5.88766 3.54494 6.59109 3.54545H7.86381V2.27325C7.86433 1.57096 7.29452 1.00104 6.59057 1C6.59109 1 6.59109 1 6.59057 1"
					fill="#36C5F0"
				/>
				<path
					d="M6.49976 4.81836H2.86388C2.11007 4.81888 1.49944 5.38869 1.5 6.09083C1.49889 6.79297 2.10951 7.36278 2.86332 7.36381H6.49976C7.25357 7.36329 7.86419 6.79349 7.86364 6.09135C7.86419 5.38869 7.25357 4.81888 6.49976 4.81836Z"
					fill="#36C5F0"
				/>
				<path
					d="M15.5 6.09083C15.5006 5.38869 14.9307 4.81888 14.2273 4.81836C13.5239 4.81888 12.9541 5.38869 12.9546 6.09083V7.36381H14.2273C14.9307 7.36329 15.5006 6.79349 15.5 6.09083Z"
					fill="#2EB67D"
				/>
				<path
					d="M11.6817 5.99972V2.36336C11.6822 1.61162 11.1128 1.00111 10.4092 1C9.70564 1.00056 9.13571 1.61106 9.13623 2.36336V5.99972C9.13519 6.75202 9.70512 7.36252 10.4087 7.36364C11.1123 7.36308 11.6822 6.75257 11.6817 5.99972Z"
					fill="#2EB67D"
				/>
				<path
					d="M10.409 14.9996C11.1124 14.999 11.6822 14.4291 11.6817 13.7268C11.6822 13.0245 11.1124 12.4546 10.409 12.4541H9.13623V13.7268C9.13571 14.4286 9.70553 14.9985 10.409 14.9996Z"
					fill="#ECB22E"
				/>
				<path
					d="M10.4995 11.1822H14.136C14.8898 11.1817 15.5004 10.6118 15.4999 9.90971C15.501 9.20756 14.8904 8.63776 14.1365 8.63672H10.5001C9.7463 8.63724 9.13567 9.20705 9.13623 9.90919C9.13567 10.6118 9.74574 11.1817 10.4995 11.1822Z"
					fill="#ECB22E"
				/>
				<path
					d="M1.5 9.90945C1.49948 10.6117 2.0693 11.1817 2.77273 11.1822C3.47616 11.1817 4.04597 10.6117 4.04545 9.90945V8.63672H2.77273C2.0693 8.63724 1.49948 9.20716 1.5 9.90945Z"
					fill="#E01E5A"
				/>
				<path
					d="M5.31836 9.99964V13.6363C5.31732 14.3887 5.88725 14.9992 6.59083 15.0004C7.2944 14.9998 7.86433 14.3892 7.86381 13.6369V10.0008C7.86485 9.24839 7.29492 8.63783 6.59135 8.63672C5.88725 8.63672 5.31784 9.24728 5.31836 9.99964C5.31836 10.0002 5.31836 9.99964 5.31836 9.99964Z"
					fill="#E01E5A"
				/>
			</svg>
		</>
	);
};
export const Twitter = () => {
	return (
		<>
			<svg width={17} viewBox="0 0 17 16" fill="none">
				<path
					d="M14.8437 5.24999C14.8645 5.33333 14.875 5.46874 14.875 5.65624C14.875 7.15624 14.5104 8.60415 13.7812 9.99998C13.0312 11.4791 11.9791 12.6562 10.625 13.5312C9.14581 14.5104 7.4479 15 5.53124 15C3.69791 15 2.02083 14.5104 0.5 13.5312C0.729166 13.5521 0.989582 13.5625 1.28125 13.5625C2.80208 13.5625 4.16666 13.0937 5.37499 12.1562C4.64582 12.1562 4.0052 11.9427 3.45312 11.5156C2.90104 11.0885 2.52083 10.5521 2.3125 9.90623C2.52083 9.92706 2.71874 9.93748 2.90624 9.93748C3.19791 9.93748 3.48958 9.90623 3.78124 9.84373C3.03124 9.67707 2.40625 9.29165 1.90625 8.68748C1.40625 8.08332 1.15625 7.39582 1.15625 6.62499V6.56249C1.61458 6.83332 2.10416 6.97915 2.62499 6.99999C2.1875 6.68749 1.83333 6.29166 1.5625 5.81249C1.29166 5.33333 1.15625 4.80728 1.15625 4.23437C1.15625 3.66145 1.3125 3.11458 1.625 2.59375C2.4375 3.61458 3.43228 4.42708 4.60936 5.03124C5.78645 5.63541 7.04165 5.96874 8.37498 6.03124C8.33331 5.78124 8.31248 5.53124 8.31248 5.28124C8.31248 4.69791 8.45831 4.15104 8.74998 3.64062C9.04165 3.13021 9.43748 2.72916 9.93748 2.4375C10.4375 2.14583 10.9791 2 11.5625 2C12.0416 2 12.4843 2.09375 12.8906 2.28125C13.2968 2.46875 13.6562 2.71875 13.9687 3.03125C14.7187 2.88541 15.4166 2.625 16.0625 2.25C15.8125 3.02083 15.3333 3.625 14.625 4.06249C15.25 3.97916 15.875 3.80208 16.5 3.53125C16.0416 4.19791 15.4895 4.77083 14.8437 5.24999Z"
					fill="#00A2F3"
				/>
			</svg>
		</>
	);
};
export const Pinterest = () => {
	return (
		<>
			<svg width={17} viewBox="0 0 17 16" fill="none">
				<path
					d="M8.87498 0C9.85415 0.0208334 10.776 0.244791 11.6406 0.671873C12.5052 1.09896 13.1875 1.6875 13.6875 2.43749C14.2291 3.24999 14.5 4.16145 14.5 5.17186C14.5 6.18228 14.3333 7.1354 14 8.03123C13.625 9.0104 13.0937 9.78123 12.4062 10.3437C11.6354 10.9687 10.7291 11.2812 9.68748 11.2812C9.27082 11.2812 8.85415 11.1823 8.43749 10.9843C8.02082 10.7864 7.71874 10.5104 7.53124 10.1562L7.28124 11.1562C7.01041 12.2396 6.79166 12.9896 6.62499 13.4062C6.37499 13.9687 5.92708 14.6875 5.28124 15.5625L5.15624 15.625L5.06249 15.5312L5.03124 15.0625C4.96874 14.4791 4.93749 14.0416 4.93749 13.75C4.93749 13.125 5.04166 12.3125 5.24999 11.3125C5.37499 10.7291 5.58333 9.86456 5.87499 8.71873L6.24999 7.21873C6.04166 6.8229 5.93749 6.30207 5.93749 5.65624C5.93749 5.05207 6.09374 4.55207 6.40624 4.15624C6.67707 3.82291 7.01041 3.61457 7.40624 3.53124C7.80207 3.44791 8.14582 3.52083 8.43749 3.74999C8.72915 3.97916 8.87498 4.34374 8.87498 4.84374C8.87498 5.11457 8.83332 5.41665 8.74999 5.74999C8.70832 5.93749 8.61457 6.22915 8.46874 6.62498C8.3229 7.02082 8.22915 7.31248 8.18749 7.49998C8.10415 7.83331 8.06249 8.12498 8.06249 8.37498C8.06249 8.77081 8.20311 9.09894 8.48436 9.35935C8.76561 9.61977 9.10415 9.74998 9.49998 9.74998C10.1666 9.74998 10.7291 9.45831 11.1875 8.87498C11.5833 8.39581 11.875 7.74998 12.0625 6.93748C12.2291 6.27082 12.3125 5.61457 12.3125 4.96874C12.3125 3.88541 11.9739 3.04166 11.2969 2.43749C10.6198 1.83333 9.72915 1.53125 8.62499 1.53125C7.81249 1.53125 7.0677 1.71875 6.39062 2.09374C5.71353 2.46874 5.18749 2.97916 4.81249 3.62499C4.4375 4.27082 4.25 5.0104 4.25 5.84374C4.25 6.1979 4.3125 6.54165 4.4375 6.87498C4.5 7.06248 4.61458 7.29165 4.78124 7.56248C4.90624 7.77081 4.96874 7.90623 4.96874 7.96873C4.96874 8.1354 4.92708 8.34373 4.84374 8.59373C4.73958 8.90623 4.62499 9.06248 4.5 9.06248C4.22916 9.06248 3.9375 8.92185 3.625 8.6406C3.3125 8.35935 3.05208 7.97915 2.84375 7.49998C2.61458 6.93748 2.5 6.31249 2.5 5.62499C2.5 4.49999 2.8125 3.49999 3.4375 2.62499C4.02083 1.8125 4.80208 1.17187 5.78124 0.703123C6.76041 0.234374 7.79165 0 8.87498 0Z"
					fill="#EA0010"
				/>
			</svg>
		</>
	);
};
export const LinkedinIn = () => {
	return (
		<>
			<svg width={15} viewBox="0 0 15 14" fill="none">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M2.1875 3.37499C1.72916 3.37499 1.33333 3.20833 0.999999 2.87499C0.666666 2.54166 0.5 2.14583 0.5 1.6875C0.5 1.22916 0.666666 0.833331 0.999999 0.499999C1.33333 0.166666 1.72916 0 2.1875 0C2.64583 0 3.04166 0.166666 3.37499 0.499999C3.70833 0.833331 3.87499 1.22916 3.87499 1.6875C3.87499 2.14583 3.70833 2.54166 3.37499 2.87499C3.04166 3.20833 2.64583 3.37499 2.1875 3.37499ZM3.62499 14H0.718749V4.65624H3.62499V14ZM11.5937 14H14.5V8.87498C14.5 7.43748 14.2916 6.37498 13.875 5.68749C13.3333 4.83332 12.3854 4.40624 11.0312 4.40624C10.3646 4.40624 9.78123 4.57291 9.28123 4.90624C8.8229 5.17707 8.48956 5.52082 8.28123 5.93749H8.24998V4.65624H5.46874V14H8.34373V9.37498C8.34373 8.64581 8.4479 8.09373 8.65623 7.71873C8.92706 7.21873 9.39581 6.96873 10.0625 6.96873C10.7291 6.96873 11.1771 7.24998 11.4062 7.81248C11.5312 8.14581 11.5937 8.68748 11.5937 9.43748V14Z"
					fill="#017EB2"
				/>
			</svg>
		</>
	);
};
export const BannerArrowIcon = () => {
	return (
		<svg width={193} viewBox="0 0 193 44" fill="none">
			<rect
				x={1}
				y={1}
				width={125}
				height={42}
				rx={21}
				stroke="white"
				strokeWidth={2}
			/>
			<g filter="url(#filter0_d_758_4217)">
				<path
					d="M64 21C63.4477 21 63 21.4477 63 22C63 22.5523 63.4477 23 64 23L64 21ZM186.707 22.7071C187.098 22.3166 187.098 21.6834 186.707 21.2929L180.343 14.9289C179.953 14.5384 179.319 14.5384 178.929 14.9289C178.538 15.3195 178.538 15.9526 178.929 16.3432L184.586 22L178.929 27.6569C178.538 28.0474 178.538 28.6806 178.929 29.0711C179.319 29.4616 179.953 29.4616 180.343 29.0711L186.707 22.7071ZM64 23L186 23L186 21L64 21L64 23Z"
					fill="white"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_758_4217"
					x={57}
					y="12.6357"
					width={136}
					height="26.7285"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={4} />
					<feGaussianBlur stdDeviation={3} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0313725 0 0 0 0 0.12549 0 0 0 0 0.196078 0 0 0 0.36 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_758_4217"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_758_4217"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
export const SearchIcon = () => {
	return (
		<svg width={16} viewBox="0 0 16 16" fill="none">
			<path
				d="M3.27344 8.58594C4.0026 9.3151 4.88802 9.67969 5.92969 9.67969C6.97135 9.67969 7.85677 9.3151 8.58594 8.58594C9.3151 7.85677 9.67969 6.97135 9.67969 5.92969C9.67969 4.88802 9.3151 4.0026 8.58594 3.27344C7.85677 2.54427 6.97135 2.17969 5.92969 2.17969C4.88802 2.17969 4.0026 2.54427 3.27344 3.27344C2.54427 4.0026 2.17969 4.88802 2.17969 5.92969C2.17969 6.97135 2.54427 7.85677 3.27344 8.58594ZM10.9297 9.67969L15.0703 13.8203L13.8203 15.0703L9.67969 10.9297V10.2656L9.44531 10.0312C8.45573 10.8906 7.28385 11.3203 5.92969 11.3203C4.41927 11.3203 3.13021 10.7995 2.0625 9.75781C1.02083 8.71615 0.5 7.4401 0.5 5.92969C0.5 4.41927 1.02083 3.14323 2.0625 2.10156C3.13021 1.03385 4.41927 0.5 5.92969 0.5C7.4401 0.5 8.71615 1.03385 9.75781 2.10156C10.7995 3.14323 11.3203 4.41927 11.3203 5.92969C11.3203 6.47656 11.1901 7.10156 10.9297 7.80469C10.6693 8.48177 10.3698 9.02865 10.0312 9.44531L10.2656 9.67969H10.9297Z"
				fill="white"
				fillOpacity="0.5"
			/>
		</svg>
	);
};

export const Close = () => {
	return (
		<>
			<svg width={18} x={0} y={0} viewBox="0 0 512 512">
				<g>
					<g id="_02_User" data-name="02 User">
						<path
							d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"
							fill="var(--redish)"
							data-original="var(--redish)"
						/>
						<path
							d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"
							fill="var(--redish)"
							data-original="var(--redish)"
						/>
					</g>
				</g>
			</svg>
		</>
	);
};

export const Bar = () => {
	return (
		<svg width={31} height={30} viewBox="0 0 31 30" fill="none">
			<g clipPath="url(#clip0_3_218)">
				<path
					d="M22.8193 22.5V25H7.81934V22.5H22.8193ZM26.5693 13.75V16.25H4.06934V13.75H26.5693ZM22.8193 5V7.5H7.81934V5H22.8193Z"
					fill="var(--white)"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3_218">
					<rect
						width={30}
						height={30}
						fill="var(--white)"
						transform="translate(0.319336)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
export const Wallet = () => {
	return (
		<svg width={15} viewBox="0 0 15 14" fill="none">
			<path
				d="M9.17969 7.80859C9.41406 8.01953 9.68359 8.125 9.98828 8.125C10.293 8.125 10.5508 8.01953 10.7617 7.80859C10.9961 7.59766 11.1133 7.32812 11.1133 7C11.1133 6.67188 10.9961 6.40234 10.7617 6.19141C10.5508 5.98047 10.293 5.875 9.98828 5.875C9.68359 5.875 9.41406 5.98047 9.17969 6.19141C8.96875 6.40234 8.86328 6.67188 8.86328 7C8.86328 7.32812 8.96875 7.59766 9.17969 7.80859ZM7 9.98828V4.01172H14.4883V9.98828H7ZM13.75 11.5V12.2383C13.75 12.6367 13.5977 12.9883 13.293 13.293C12.9883 13.5977 12.6367 13.75 12.2383 13.75H1.76172C1.33984 13.75 0.976562 13.6094 0.671875 13.3281C0.390625 13.0234 0.25 12.6602 0.25 12.2383V1.76172C0.25 1.33984 0.390625 0.988281 0.671875 0.707031C0.976562 0.402344 1.33984 0.25 1.76172 0.25H12.2383C12.6367 0.25 12.9883 0.402344 13.293 0.707031C13.5977 1.01172 13.75 1.36328 13.75 1.76172V2.5H7C6.57812 2.5 6.21484 2.65234 5.91016 2.95703C5.62891 3.23828 5.48828 3.58984 5.48828 4.01172V9.98828C5.48828 10.4102 5.62891 10.7734 5.91016 11.0781C6.21484 11.3594 6.57812 11.5 7 11.5H13.75Z"
				fill="white"
			/>
		</svg>
	);
};
export const ArrowIcon = () => {
	return (
		<svg width={11} viewBox="0 0 11 11" fill="none">
			<path
				d="M4 0.34375H10.6562V7H9.34375V2.59375L1.59375 10.3438L0.65625 9.40625L8.40625 1.65625H4V0.34375Z"
				fill="#19995E"
			/>
		</svg>
	);
};
export const Share = () => {
	return (
		<svg width={18} viewBox="0 0 18 18" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.95388 10.847C5.58304 11.2224 5.06798 11.4551 4.49858 11.4551C3.36891 11.4551 2.45312 10.5393 2.45312 9.40962C2.45312 8.27995 3.36891 7.36417 4.49858 7.36417C5.08158 7.36417 5.60761 7.60808 5.98021 7.99942L11.5084 4.9748C11.4723 4.82259 11.4531 4.66379 11.4531 4.50053C11.4531 3.37086 12.3689 2.45508 13.4986 2.45508C14.6283 2.45508 15.544 3.37086 15.544 4.50053C15.544 5.63021 14.6283 6.54599 13.4986 6.54599C12.935 6.54599 12.4246 6.31805 12.0547 5.94933L6.50056 8.98814C6.52905 9.12416 6.54403 9.26514 6.54403 9.40962C6.54403 9.52866 6.53387 9.64531 6.51435 9.75878L11.2245 12.0638C11.5954 11.688 12.1107 11.4551 12.6804 11.4551C13.8101 11.4551 14.7259 12.3709 14.7259 13.5005C14.7259 14.6302 13.8101 15.546 12.6804 15.546C11.5507 15.546 10.6349 14.6302 10.6349 13.5005C10.6349 13.3818 10.6451 13.2654 10.6645 13.1522L5.95388 10.847ZM13.4986 5.31871C13.9505 5.31871 14.3168 4.9524 14.3168 4.50053C14.3168 4.04866 13.9505 3.68235 13.4986 3.68235C13.0467 3.68235 12.6804 4.04866 12.6804 4.50053C12.6804 4.9524 13.0467 5.31871 13.4986 5.31871ZM4.49858 10.2278C4.95045 10.2278 5.31676 9.8615 5.31676 9.40963C5.31676 8.95776 4.95045 8.59144 4.49858 8.59144C4.04671 8.59144 3.6804 8.95776 3.6804 9.40963C3.6804 9.8615 4.04671 10.2278 4.49858 10.2278ZM12.6804 14.3187C13.1323 14.3187 13.4986 13.9524 13.4986 13.5005C13.4986 13.0487 13.1323 12.6824 12.6804 12.6824C12.2285 12.6824 11.8622 13.0487 11.8622 13.5005C11.8622 13.9524 12.2285 14.3187 12.6804 14.3187Z"
				fill="white"
			/>
		</svg>
	);
};
export const AngleDown = () => {
	return (
		<svg width={10} viewBox="0 0 10 6" fill="none">
			<path
				d="M8.44531 0.433594L9.5 1.48828L5 5.98828L0.5 1.48828L1.55469 0.433594L5 3.87891L8.44531 0.433594Z"
				fill="white"
				fillOpacity="0.5"
			/>
		</svg>
	);
};
export const Dots = ({ fill }) => {
	return (
		<svg width={10} viewBox="0 0 10 10" fill="none">
			<circle cx={5} cy={5} r={5} fill={fill} />
			<mask
				id="mask0_835_471"
				style={{ maskType: "alpha" }}
				maskUnits="userSpaceOnUse"
				x={0}
				y={0}
				width={10}
				height={10}
			>
				<circle cx={5} cy={5} r={5} fill="white" />
			</mask>
			<g mask="url(#mask0_835_471)" />
		</svg>
	);
};
export const Calendar = () => {
	return (
		<svg width={14} viewBox="0 0 14 16" fill="none">
			<path
				d="M8.33398 10.0117V11.4883H3.06055V10.0117H8.33398ZM12.0605 13.7383V5.51172H1.58398V13.7383H12.0605ZM12.0605 1.75C12.459 1.75 12.8105 1.90234 13.1152 2.20703C13.4199 2.51172 13.5723 2.86328 13.5723 3.26172V13.7383C13.5723 14.1367 13.4199 14.4883 13.1152 14.793C12.8105 15.0977 12.459 15.25 12.0605 15.25H1.58398C1.16211 15.25 0.798828 15.1094 0.494141 14.8281C0.212891 14.5234 0.0722656 14.1602 0.0722656 13.7383V3.26172C0.0722656 2.86328 0.212891 2.51172 0.494141 2.20703C0.798828 1.90234 1.16211 1.75 1.58398 1.75H2.32227V0.238281H3.83398V1.75H9.81055V0.238281H11.3223V1.75H12.0605ZM10.584 6.98828V8.5H3.06055V6.98828H10.584Z"
				fill="#EBF0F0"
			/>
		</svg>
	);
};
